export interface ReleaseNote { version: string; date: string; items: string[] }

export const RELEASE_NOTES: ReleaseNote[] = [
  {
    version: 'v1.9.1', date: '2026-10-11',
    items: [
      '筆順新增「🎓 綜合學習」：精選 108 字涵蓋 214 個部首與 16 條筆順規則，分成 5 份由簡單到複雜，一次學一份；可在「⚙️ 設定」改成自己的字集，也能一鍵還原系統預設',
      '筆順新增「⭐ 我的最愛」：遇到筆順特別的字就加星號，之後一鍵帶入複習；綜合學習字集與我的最愛會同步到雲端，換裝置也能用',
      '學習日曆新增記錄：閃卡張數、心智圖、配對練習（成功對數與選錯次數）、字典與筆順查字次數',
      '有新版本時不再自動重新整理（會中斷作答），改成畫面上方提示「有新版本」，按「立即更新」才換版',
      '作答解說裡的選項字母（如「故選 (C)」）會依選項被隨機排列後的畫面，改顯示成完整的選項文字，不再誤導',
      '作答頁上方新增 🚩 回報錯誤按鈕，題目一出現就能回報；回報改用 App 內輸入視窗並暫停計時；後台「回報」分頁與 🛠️ 紅點會顯示待處理回報數',
    ],
  },
  {
    version: 'v1.9.0', date: '2026-10-10',
    items: [
      '學習分析新增「日曆」：選某一天，看當天的學習時長、作答題數與正確率、各科目分布、測驗成績、看過的重點整理、答錯的題目（可直接複習）',
      '每頁都有「字典／筆順」浮動按鈕，測驗中也能查；按鈕可拖曳並記住位置',
      '主題與單元清單改版：重點整理在左、題目練習在右（保留進度與正確率）',
      '重點整理頁圖片可點開全螢幕放大；補齊段考 7 大單元全彩圖解，全科核心主題皆有心智圖',
      '段考衝刺卡與每日學習計畫（10/10～10/15）',
      '題庫全面驗證：8,669 題逐題標記已驗證，並複查修正國文字音字形與修辭、自然圖題、社會與數學講義',
      '新增國文配對題 29 組、英文單字 2,450 字、社會學習卡、國文筆順、數學統計圖轉換題',
      'iPhone 修正：字典與筆順頁不再被狀態列遮住，關閉鈕可正常點擊',
      '新增「學習方法」科目（已核准帳號可見）：整理自兩本學習方法書，10 個主題，含重點、閃卡、心智圖與 149 題（含 10 組配對）',
      '配對練習移到重點整理頁的第四個分頁；日曆加入每日學習時長與近 7 天長條圖',
    ],
  },
  {
    version: 'v1.8.0', date: '2026-06-28',
    items: [
      '主題配置系統（8 款命名主題，深淺色一體）',
      '首頁字體大小快捷鍵（A+/A-）',
      '後台學生學習狀況儀表板',
      '後台管理更名',
      '關於頁面 & 版本記錄',
    ],
  },
  {
    version: 'v1.7.0', date: '2026-06',
    items: [
      '閃卡重點整理功能',
      '重點整理學習記錄寫入 Firestore',
      '後台重點整理管理介面',
      '理化第四冊題庫（有機化合物、常見的力）',
      '英文第四冊題庫（L5/L6 單字 & 文法）',
      '自訂科目支援',
    ],
  },
  {
    version: 'v1.6.0', date: '2026-05',
    items: [
      '10 款背景音樂',
      '字型大小調整（個人設定）',
      '深色/淺色模式切換',
      '頭像上傳',
      '題目回報錯誤功能',
    ],
  },
  {
    version: 'v1.5.0', date: '2026-04',
    items: [
      '學習單元分層（依概念分組）',
      '錯題銀行 & 學習分析',
      '排行榜歷史紀錄',
      '題庫 JSON/CSV 匯出',
      '忘記密碼',
    ],
  },
];
